import { render, staticRenderFns } from "./ServerDiskState.vue?vue&type=template&id=2c458134&scoped=true&"
import script from "./ServerDiskState.vue?vue&type=script&lang=js&"
export * from "./ServerDiskState.vue?vue&type=script&lang=js&"
import style0 from "./ServerDiskState.vue?vue&type=style&index=0&id=2c458134&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c458134",
  null
  
)

export default component.exports